import { CustomerBillingModel, CustomerModel } from 'api-hooks/customer';
import { Option } from 'baseui/select';
import { transformLabel } from 'common/utils/string';
import { Input } from 'components/elements';
import CustomerSelectInput from 'legacy-modules/master/customer/components/select-input';
import CustomerBillingSelectInput from 'legacy-modules/sales/component/customer-billing-select-input';
import TransactionAt from 'legacy-modules/sales/component/transaction-at';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormType } from './form-type';

interface Props {
  isFilled?: boolean;
}

function transformer(item: CustomerBillingModel): Option {
  return {
    id: item.id,
    label: transformLabel([item.name, item.address, item.phone]),
  };
}

export default function InformationField(props: Props) {
  const { t } = useTranslation();

  const { setValue } = useFormContext<FormType>();
  const onAfterDetailChangeCustomer = React.useCallback(
    (params: CustomerModel) => {
      const _options = params.billings.map((billing) => transformer(billing));
      setValue('customerBillingOptions', _options);
    },
    [setValue],
  );

  return (
    <FullContainer>
      <SectionContainer>
        <HalfContainer
          $style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
          }}
        >
          <TransactionAt
            clearable={false}
            name="transactionAt"
            label={t('common:transaction_at')}
            placeholder={t('common:transaction_at')}
            required
          />
        </HalfContainer>

        {props.isFilled && (
          <HalfContainer>
            <Input
              type="text"
              name="number"
              label={t('receipt:receipt_number')}
              placeholder={t('receipt:receipt_number')}
              disabled
            />
          </HalfContainer>
        )}
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <CustomerSelectInput
            name="customerId"
            required
            onAfterDetailChange={onAfterDetailChangeCustomer}
          />
        </HalfContainer>
        <HalfContainer>
          <CustomerBillingSelectInput name="customerBillingId" />
        </HalfContainer>
      </SectionContainer>
      <FullContainer>
        <Input
          type="text-area"
          name="description"
          label={t('common:description')}
          placeholder={t('common:description')}
        />
      </FullContainer>
    </FullContainer>
  );
}
